(function(){
  /* mobile nav */
  var b=document.querySelector('.burger'), n=document.querySelector('.mobile-nav');
  if(b&&n){b.addEventListener('click',function(){n.classList.toggle('open');
    b.textContent=n.classList.contains('open')?'Close':'Menu';});}

  /* countdown */
document.querySelectorAll('[data-countdown]').forEach(function(el){
  var raw=el.getAttribute('data-countdown');
  function target(){
    if(raw){var d=new Date(raw); if(!isNaN(d)) return d;}
    var now=new Date(), t=new Date(now);
    t.setDate(now.getDate()+((7-now.getDay())%7||7)); t.setHours(18,0,0); return t;
  }
  var T=target();
  function pad(x){return String(x).padStart(2,'0');}
  function tick(){
    var d=Math.max(0,T-new Date());
    if(d<=0){
      clearInterval(iv);
      el.innerHTML='<div class="cd-label">First Drop Live</div>';
      return;
    }
    var f=el.querySelectorAll('[data-unit]');
    f.forEach(function(u){
      var k=u.getAttribute('data-unit'), v=0;
      if(k==='d') v=Math.floor(d/864e5);
      if(k==='h') v=Math.floor(d/36e5)%24;
      if(k==='m') v=Math.floor(d/6e4)%60;
      if(k==='s') v=Math.floor(d/1e3)%60;
      u.textContent=pad(v);
    });
  }
  var iv=setInterval(tick,1000);
  tick();
});


  /* pdp gallery */
  var main=document.querySelector('[data-pdp-main]');
  if(main){
    document.querySelectorAll('[data-pdp-thumb]').forEach(function(t){
      t.addEventListener('click',function(){
        var src=t.getAttribute('data-full');
        if(src){ main.querySelector('img').setAttribute('src',src); }
        document.querySelectorAll('[data-pdp-thumb]').forEach(function(x){x.classList.remove('on');});
        t.classList.add('on');
      });
    });
  }
})();

/* ---------- motion layer ---------- */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* fade images in once decoded */
  function ready(img){ img.classList.add('ready'); }
  document.querySelectorAll('.ph img, .pdp-main img').forEach(function(img){
    if(img.complete) ready(img);
    else img.addEventListener('load', function(){ ready(img); });
  });

  if(reduce) return;

  /* scroll reveal */
  var targets = document.querySelectorAll(
    '.sec-head, .trio .col, .capture, .site-footer, .pdp-info, .page-wrap, .cart, .band'
  );
  targets.forEach(function(el){ if(!el.classList.contains('band')) el.setAttribute('data-reveal',''); });

  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function(el){ io.observe(el); });

    /* stagger the three columns */
    document.querySelectorAll('.trio .col').forEach(function(el,i){
      el.style.transitionDelay = (i * 0.12) + 's';
    });
  } else {
    targets.forEach(function(el){ el.classList.add('in'); });
  }

  /* header tucks away on scroll down */
  var hdr = document.querySelector('.site-header'), last = 0, ticking = false;
  if(hdr){
    window.addEventListener('scroll', function(){
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(function(){
        var y = window.pageYOffset;
        if(y > 220 && y > last) hdr.classList.add('tuck');
        else hdr.classList.remove('tuck');
        last = y; ticking = false;
      });
    }, { passive: true });
  }
})();

/* ---------- "I have pieces to sell" toggles the customer tag ---------- */
(function(){
  document.querySelectorAll('[data-sell-toggle]').forEach(function(cb){
    var form = cb.closest('form');
    if(!form) return;
    var field = form.querySelector('[data-tags-field]');
    if(!field) return;
    var base = field.value;
    cb.addEventListener('change', function(){
      field.value = cb.checked ? base + ',sell-to-us' : base;
    });
  });
})();
